var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import { HashRouter, Switch, Route, Redirect } from "react-router-dom";
import Home from "@codex/pages/Home";
import Survay from "@codex/pages/Survay";
import { connect } from "react-redux";
var RestrictedRoute = function (_a) {
    var Component = _a.component, isLoggedIn = _a.isLoggedIn, rest = __rest(_a, ["component", "isLoggedIn"]);
    return (React.createElement(Route, __assign({}, rest, { render: function (props) {
            return isLoggedIn ? (React.createElement(Component, __assign({}, props))) : (React.createElement(Redirect, { to: {
                    pathname: "/",
                    state: { from: props.location }
                } }));
        } })));
};
var Routes = /** @class */ (function (_super) {
    __extends(Routes, _super);
    function Routes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Routes.prototype.render = function () {
        return (React.createElement(HashRouter, null,
            React.createElement(Switch, null,
                React.createElement(Route, { exact: true, path: "/", component: Home }),
                React.createElement(RestrictedRoute, { isLoggedIn: this.props.isLoggedIn, exact: true, path: "/survey", component: Survay }))));
    };
    return Routes;
}(Component));
var mapStateToProps = function (state) {
    return {
        isLoggedIn: !!localStorage.getItem('token')
    };
};
export default connect(mapStateToProps)(Routes);



//////////////////
// WEBPACK FOOTER
// ./src/routes/index.tsx
// module id = 1343
// module chunks = 0